import {
  navbarDesktopView,
  navbarDropdownItemDescriptionV2,
  navbarDropdownItemTitleV2,
  navbarMobileView,
} from './Navbar.css';

export const NavbarStylesV2 = {
  navbarDropdownItemDescriptionV2,
  navbarDropdownItemTitleV2,
  navbarDesktopView,
  navbarMobileView,
};
